module.exports = __webpack_public_path__ + "content/dam/oppo/coloros/img/img_1.58a89101.png";